import { shortcutManager } from "../../utils/shortcut-manager/ShortcutManager.const";
import { DialogBackdrop } from "../dialog-backdrop/DialogBackdrop";
import { DialogDirector } from "./DialogDirector";
import { IDialogDirector } from "./interfaces/IDialogDirector";

const backdrop = new DialogBackdrop();
backdrop.initialise();

export const dialogDirector: IDialogDirector = new DialogDirector(backdrop, shortcutManager);
